import * as api from '@tytapp/api';
import { Model } from '@tytapp/common';

@Model('Announcement')
export class Announcement extends api.ApiAnnouncement {

    static API = api.AnnouncementsApi;
    
}
